// extracted by css-extract-rspack-plugin
export default {"cls1":"SidebarAddComment-cls1_n8M","cls2":"SidebarAddComment-cls2_o0J SidebarAddComment-cls1_n8M"};